import { useContext } from 'react';
import clsx from 'clsx';

import WorkOrderContext from '@atom/components/workOrderDetail/WorkOrderContext';
import { setDurationDisplay } from '@atom/utilities/timeUtilities';

import classes from './taskDetailView.module.css';

const TaskDuration = () => {
  const { task } = useContext(WorkOrderContext);

  return (
    <div className={clsx(classes.timeRowItem, classes.duration)}>
      <div className={classes.labelContainer}>
        <div className={classes.label}>Duration</div>
      </div>
      <div className={classes.dateDisplay}>
        {setDurationDisplay(task.duration)}
      </div>
    </div>
  );
};

export default TaskDuration;
